import Axios from 'axios'

/**
 * Use good names to identify errors.
 *
 *  Text structure:
 *
 *      `#name-of-resource - messsage`
 *
 *  Good usage:
 *
 *      `#api-propostas-get-all - Houve um erro ao retornar as propostas`
 *
 *  Bad usage:
 *
 *      `#api-error-1238123 - Houve um error ao retornar as proposas`
 *
 */
export class ERROR_TEXTS {
	static readonly ERROR_API_SAMPLE = '#api-sample-get-code - Houve um erro ao fazer a requisição da API'
	static readonly ERROR_API_MINHAS_PROPOSTAS_GET_ALL = '#api-minhas-propostas-get-all - Houve um erro ao retornar as propostas.'
	static readonly ERROR_API_MINHAS_PROPOSTAS_GET_NEW_PROPOSAL =
		'#api-minhas-propostas-get-new-proposal - Houve um erro ao retornar uma nova proposta.'
	static readonly ERROR_API_MINHAS_PROPOSTAS_GET_USER_DETAILS =
		'#api-minhas-propostas-get-user-details - Houve um erro ao retornar os detalhes do usuário.'
	static readonly ERROR_API_MULTIBANK_GET_ANALYSIS_DETAILS =
		'#api-multibank-get-analysis-details - Houve um erro ao retornar os detalhes da análise.'
	static readonly ERROR_API_MULTIBANK_SHARE_LINK = '#api-multibank-share-link - Houve um erro ao retornar o link para compartilhamento.'

	static readonly ERROR_API_MULTIBANK_SAVE = '#api-multibank-save - Houve um erro ao salvar a proposta.'
	static readonly ERROR_API_MULTIBANK_RESEND = '#api-multibank-resend - Houve um erro ao reenviar a proposta para o banco.'
	static readonly ERROR_API_SET_NOTIFICATION_READ = '#api-notification-set-read - Houve um erro ao marcar a notificação como lida.'

	static readonly ERROR_API_PROPOSAL_CALL_ANALYST = '#api-proposal-call-analyst - Houve um erro ao enviar para um analista.'
	static readonly ERROR_API_PROPOSAL_CALL_OWNER = '#api-proposal-call-owner - Houve um erro ao enviar para o responsável da proposta.'
	static readonly ERROR_API_PROPOSAL_ADD_MESSAGE = '#api-proposal-add-message - Houve um erro ao adicionar uma mensagem.'
	static readonly ERROR_API_PROPOSAL_GET = '#api-proposal-get - Houve um erro ao retornar as informações da proposta.'
	static readonly ERROR_API_PROPOSAL_GET_HISTORY = '#api-proposal-get-history - Houve um erro ao retornar o histórico da proposta.'
	static readonly ERROR_API_DOCUMENT_GET_TYPES = '#api-document-get-types - Houve um erro ao retornar os tipos de documentos.'
	static readonly ERROR_API_UPLOAD_ERROR = '#api-upload-error - Houve um erro ao fazer o upload do arquivo.'
	static readonly ERROR_API_DOCUMENT_GET = '#api-document-get - Houve um erro ao retornar os documentos.'
	static readonly ERROR_API_DOCUMENT_CHANGE_STATUS = '#api-document-change-status - Houve um erro ao alterar o status do documento.'
	static readonly ERROR_DOWNLOAD_DOCUMENTS = '#api-download-documents - Houve um erro ao fazer o download dos documentos.'
}

export const BUSINESS_ERRORS = {
	4221: 'Erro! São aceitas apenas minutas em PDF e não digitalizadas',
	4222: 'Erro! São aceitas apenas minutas em PDF'
} as {
	[errorCode: number]: string
}

export function IsBusinessError(err: unknown): string | null {
	if (Axios.isAxiosError(err)) {
		if ('businessCode' in err.response?.data) {
			return BUSINESS_ERRORS[err.response?.data?.businessCode]
		} else {
			return err.response?.data.error
		}
	}

	return null
}
